function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 5C8.129 5 5 8.129 5 12C5 15.871 8.129 19 12 19C15.871 19 19 15.871 19 12C19 8.129 15.871 5 12 5ZM12 17.6C8.913 17.6 6.4 15.087 6.4 12C6.4 8.913 8.913 6.4 12 6.4C15.087 6.4 17.6 8.913 17.6 12C17.6 15.087 15.087 17.6 12 17.6ZM14.513 9.513L11.026 13.013L9.026 11.513L8.039 12.5L11 15L13.526 12.5L14.513 11.513L15.5 10.5L14.513 9.513Z",
  fill: "#072E4B"
});

var SvgRevertlesson = function SvgRevertlesson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRevertlesson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/revertlesson.62d18b8c.svg";
export { ForwardRef as ReactComponent };